(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  function ehRefreshLucideIcons() {
    if (!window.lucide || typeof window.lucide.createIcons !== 'function') return;
    window.lucide.createIcons({ attrs: { 'stroke-width': 1.6 } });
  }

  function ehWatchCartIcon() {
    var cartBubble = document.getElementById('cart-icon-bubble');
    if (!cartBubble || cartBubble.dataset.ehIconObserver === 'true') return;
    cartBubble.dataset.ehIconObserver = 'true';
    new MutationObserver(function () {
      window.requestAnimationFrame(ehRefreshLucideIcons);
    }).observe(cartBubble, { childList: true, subtree: true });
  }

  function ehBindCartDrawer() {
    var cartLink = document.getElementById('cart-icon-bubble');
    if (!cartLink || cartLink.dataset.ehCartBound === 'true') return;

    cartLink.dataset.ehCartBound = 'true';
    var pointerOpenedDrawer = false;

    function openDrawer(event) {
      var cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer || typeof cartDrawer.open !== 'function') return false;

      event.preventDefault();
      event.stopImmediatePropagation();
      cartDrawer.open(cartLink);
      return true;
    }

    cartLink.addEventListener('pointerup', function (event) {
      pointerOpenedDrawer = openDrawer(event);
      window.setTimeout(function () {
        pointerOpenedDrawer = false;
      }, 500);
    }, true);

    cartLink.addEventListener('click', function (event) {
      if (pointerOpenedDrawer) {
        event.preventDefault();
        event.stopImmediatePropagation();
        pointerOpenedDrawer = false;
        return;
      }

      openDrawer(event);
    }, true);
  }

  if (!window.ehHeaderInteractionsReady) {
    window.ehHeaderInteractionsReady = true;
    document.addEventListener('click', function (event) {
      document.querySelectorAll('.eh-header__dropdown[open], .eh-mobile-nav[open]').forEach(function (details) {
        if (!details.contains(event.target)) details.removeAttribute('open');
      });
    });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('.eh-header__dropdown[open], .eh-mobile-nav[open]').forEach(function (details) {
        details.removeAttribute('open');
      });
    });
  }

  ehRefreshLucideIcons();
  ehWatchCartIcon();
  ehBindCartDrawer();

  document.addEventListener('shopify:section:load', function () {
    ehRefreshLucideIcons();
    ehWatchCartIcon();
    ehBindCartDrawer();
  });

  } catch(e) { console.error(e); }
})();
})();
